/**
 * Owner: Masa Bayu
 * File: qx-writer-theme.ts
 * Date:Time: 2026-10-05 16:35
 * Description: Fasa 33-A GREEN · Lexical theme · qxw-* CSS class map.
 */

import type { EditorThemeClasses } from 'lexical';

export function getEditorTheme(): EditorThemeClasses {
  return {
    root: 'qxw-root',
    paragraph: 'qxw-paragraph',
    text: {
      bold: 'qxw-text-bold',
      italic: 'qxw-text-italic',
      underline: 'qxw-text-underline',
      strikethrough: 'qxw-text-strikethrough',
      subscript: 'qxw-text-subscript',
      superscript: 'qxw-text-superscript',
      code: 'qxw-text-code',
    },
  };
}
